"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
var alert_component_1 = require("./alert.component");
Object.defineProperty(exports, "Alert", { enumerable: true, get: function () { return alert_component_1.Alert; } });
